import React from 'react';

import { BaseIconProps } from './';

export const Plus = ({ fill }: BaseIconProps) => (
  <path
    transform="matrix(2.109375,0,0,-2.109375,0,1080)"
    d="M 214,512 V 298 H 0 V 214 H 214 V 0 h 84 v 214 h 214 v 84 H 298 v 214 z"
    fill={fill}
  />
);
